import firebase from "firebase/app";
import "firebase/storage";
import * as util from "@/util";

export async function getStorageURL(path: string): Promise<string> {
  return firebase.storage().ref(path).getDownloadURL();
}

export async function removeStorageFileIfTemp(path: string): Promise<boolean> {
  if (isTempUploadRef(path)) {
    return removeStorageFile(path);
  }
  return false;
}

export async function removeStorageFile(path: string): Promise<boolean> {
  util.log("Removing", path);
  if (!path) {
    return Promise.resolve(false);
  }
  await firebase.storage().ref(path).delete();
  return true;
}

export class UploadPromise {
  uploadTask: firebase.storage.UploadTask;
  promise: Promise<void>;
  constructor(uploadTask: firebase.storage.UploadTask, promise: Promise<void>) {
    this.uploadTask = uploadTask;
    this.promise = promise;
  }

  cancel(): boolean {
    return this.uploadTask.cancel();
  }
}

export type StateChangedFunc = (transferred: number, total: number) => void;
export function uploadToStorage(path: string, file: File, stateChanged: StateChangedFunc): UploadPromise {
  util.log("Uploading", path);
  const ref = firebase.storage().ref(path);
  const metadata = {
    contentType: file.type
  };
  const uploadTask = ref.put(file, metadata);
  uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (partialSnap) => {
    stateChanged(partialSnap.bytesTransferred, partialSnap.totalBytes);
  });
  return new UploadPromise(
    uploadTask,
    new Promise((resolve, reject) => {
      uploadTask.then(() => resolve()).catch((err) => reject(err));
    })
  );
}

export function makeTempUploadRef(uid: string, fname: string): string {
  return `uploads/${uid}/${+new Date()}-${fname}`;
}

export function isTempUploadRef(fileRef: string) {
  return fileRef.startsWith("uploads/");
}
